import React, { useEffect, useState } from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { S } from './ProjectDialogs.styles';
import { Input } from '../../../../../../../components/Input';
import { useRenameProject } from '../../../../../../../traits/api/projects/useRenameProject';
import { ProjectRowTarget } from './ActionsCell';

type Props = {
  target: ProjectRowTarget | null;
  onClose: () => void;
};

export const RenameProjectDialog: React.FC<Props> = ({ target, onClose }) => {
  const [name, setName] = useState('');
  const mutation = useRenameProject();

  useEffect(() => {
    setName(target?.name ?? '');
  }, [target]);

  const handleSave = () => {
    if (!target || !name.trim()) return;
    mutation.mutate({ projectId: target.projectId, name: name.trim() });
    onClose();
  };

  return (
    <AlertDialog.Root open={!!target}>
      <AlertDialog.Portal>
        <S.Overlay>
          <S.Wrapper>
            <S.ContentContainer>
              <AlertDialog.Title asChild>
                <S.H5>Byt namn på projekt</S.H5>
              </AlertDialog.Title>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Skriv projektnamn"
              />
            </S.ContentContainer>
            <S.ButtonContainer>
              <AlertDialog.Cancel asChild onClick={onClose}>
                <S.Button $outlined>Avbryt</S.Button>
              </AlertDialog.Cancel>
              <AlertDialog.Action asChild>
                <S.Button onClick={handleSave} disabled={!name.trim()}>
                  Spara
                </S.Button>
              </AlertDialog.Action>
            </S.ButtonContainer>
          </S.Wrapper>
        </S.Overlay>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
